import React, { useState } from "react";
import ImageUploader from "components/atoms/ImageUploader";
import Alubum, { Photo } from "components/molecures/Allbum";
import { DialogTitle, TextField, DialogContent } from "@material-ui/core";
import { listImages } from "graphql/queries";
import { v4 as uuid } from "uuid";
import { createImage } from "../../graphql/mutations";
import awsconfig from "aws-exports";
import { API, graphqlOperation } from "aws-amplify";
import { Storage } from "aws-amplify";
import { cfOrigin } from "settings/storageSettings";
import { useSelector } from "react-redux";
import { Image } from "API";

type Props = {
  onSelect: any;
  value: any;
};
const UploadImage = (props: Props) => {
  const { value, onSelect } = props;

  const show = useSelector((state: any) => state.user.selectedShow);
  const [search, setSerach] = useState("");
  const [registPhots, setRegistPhots] = useState<Photo[]>([]); //選択候補フォト

  React.useEffect(() => {
    const f = async () => {
      const res = await API.graphql(
        graphqlOperation(listImages, {
          limit: 2000,
          filter: { alternate: { contains: search } },
        })
      );
      // @ts-ignore
      const res_photos = res.data.listImages.items
        .sort(
          (a: Image, b: Image) => new Date(b.updatedAt) - new Date(a.updatedAt)
        )
        .map((item) => {
          return {
            id: item.id,
            src: item.url,
            width: 3,
            height: 4,
            order: null,
            name: item.alternate,
          };
        });
      setRegistPhots(res_photos);
    };
    f();
  }, [search]);

  const _addOwnerValue = (input: any) => {
    if (show) {
      input["owner"] = show.owner;
    }
    return input;
  };

  // 写真アップした際の挙動
  const saveStorage = async (input: any[]) => {
    let upPhots = [];
    await Promise.all(
      input.map(async (val) => {
        console.log("val:", val);
        const [, , , extension] = /([^.]+)(\.(\w+))?$/.exec(val.name);
        let storage: any = await Storage.put(
          `${uuid()}${extension && "."}${extension}`,
          val
        );
        console.log("successfully saved file...");

        const s3object = {
          bucket: awsconfig.aws_user_files_s3_bucket,
          region: awsconfig.aws_user_files_s3_bucket_region,
          key: storage.key,
        };
        const url = await Storage.get(s3object.key, {
          level: "public",
          download: false,
        });

        const parser = new URL(url);

        let imagePath = "";
        if (cfOrigin) {
          imagePath = `${cfOrigin}${parser.pathname}`;
        } else {
          imagePath = `${parser.origin}${parser.pathname}`;
        }
        const image = (await API.graphql(
          graphqlOperation(createImage, {
            input: _addOwnerValue({
              alternate: val.name,
              url: imagePath,
              storage: s3object,
            }),
          })
        )) as any;
        upPhots.push({
          id: image.data.createImage.id,
          src: image.data.createImage.url,
          width: 3,
          height: 4,
          name: image.data.createImage.alternate,
        });
      })
    ).then((val) => {
      setRegistPhots([...registPhots, ...upPhots]);
    });
  };

  return (
    <>
      <DialogTitle>
        <TextField
          label="search"
          value={search}
          onChange={(event: any) => {
            setSerach(event.target.value);
          }}
        />
        <ImageUploader
          {...props}
          onDrop={(picture: any[]) => {
            saveStorage(picture);
          }}
        />
      </DialogTitle>

      <DialogContent>
        <Alubum
          photos={registPhots}
          mode="check"
          onChange={() => {}}
          onSelect={onSelect}
        />
      </DialogContent>
    </>
  );
};

export default UploadImage;
